export default __webpack_public_path__ + "media/images/partners/cirm-14d37ae5a144fe1e02a797f5306ec05b.jpg";